import type { SVGProps } from "react"
import React from "react"

export const LinkedIn: React.FC<SVGProps<SVGSVGElement>> = ({
  width = 28,
  height = 28,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  >
    <title> Linkedin Icon</title>
    <path
      fill="currentColor"
      d="M26.2857 4H5.66071C4.75 4 4 4.80357 4 5.76786V26.2857C4 27.25 4.75 28 5.66071 28H26.2857C27.1964 28 28 27.25 28 26.2857V5.76786C28 4.80357 27.1964 4 26.2857 4ZM11.2321 24.5714H7.69643V13.1607H11.2321V24.5714ZM9.46429 11.5536C8.28571 11.5536 7.375 10.6429 7.375 9.51786C7.375 8.39286 8.28571 7.42857 9.46429 7.42857C10.5893 7.42857 11.5 8.39286 11.5 9.51786C11.5 10.6429 10.5893 11.5536 9.46429 11.5536ZM24.5714 24.5714H20.9821V19C20.9821 17.7143 20.9821 16 19.1607 16C17.2857 16 17.0179 17.4464 17.0179 18.9464V24.5714H13.4821V13.1607H16.8571V14.7143H16.9107C17.3929 13.8036 18.5714 12.8393 20.2857 12.8393C23.875 12.8393 24.5714 15.25 24.5714 18.3036V24.5714Z"
    />
  </svg>
)
